// TODO - remove lint disable when editing this file
/* eslint-disable */
import { forEach } from 'lodash'
import { ContentBlock, genKey } from 'draft-js'
import { Map } from 'immutable'
import BaseConverter from './BaseConverter'

export default class HeadlineConverter extends BaseConverter {
  constructor(ansType = 'headline', draftTypes = ['header-one']) {
    super(ansType, draftTypes)
    this.keyMap = {
      mobile: 'mobile',
      native: 'native',
      print: 'print',
      tablet: 'tablet',
      web: 'web',
      metaTitle: 'meta_title',
    }
  }

  setMetaData(element = {}, [block], context) {
    const data = {}
    forEach(this.keyMap, (ansKey, key) => {
      data[key] = element[ansKey]
    })

    return [context.setAnsElementMetaData(block.getKey(), Map(data))]
  }

  appendAndGetBlocks(element = {}, context) {
    const { basic = '' } = element || {}
    const blocks = [
      new ContentBlock({
        key: genKey(),
        type: this.getDraftTypes()[0],
        text: basic,
      }),
    ]
    return context.appendBlock(blocks)
  }

  populateMetaData(ansData, [block]) {
    const data = ansData || {}
    const blockData = block.getData()
    forEach(this.keyMap, (ansKey, key) => {
      data[ansKey] = blockData.get(key, '').trim()
    })

    return data
  }

  toAnsDataFromBlocks(contentState, [block]) {
    return {
      basic: block.getText(),
    }
  }
}
